import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
export const JOB_UPDATE_EVENT_NAME = 'JobUpdate';
function patchRelationshipPdf(task, payload) {
    if (payload.status === 'ready') {
        return _object_spread_props(_object_spread({}, task), {
            status: 'ready',
            progress: 100,
            downloadUrl: payload.downloadUrl,
            fileName: payload.fileName,
            updatedAt: Date.now()
        });
    }
    if (payload.status === 'failed') {
        return _object_spread_props(_object_spread({}, task), {
            status: 'failed',
            progress: 100,
            error: payload.error,
            updatedAt: Date.now()
        });
    }
    return _object_spread_props(_object_spread({}, task), {
        status: payload.status,
        progress: payload.progress
    });
}
export function applyJobPatch(task, payload) {
    switch(task.kind){
        case 'relationshipPdf':
            if (payload.kind !== 'relationshipPdf') return task;
            return patchRelationshipPdf(task, payload);
        default:
            {
                const _exhaustive = task.kind;
                return _exhaustive;
            }
    }
}
